import { Dispatch } from "redux";
import { WaterfallGL } from "src/pages/CrewSchedule/gl/WaterfallGL";
import { setTimelineLink } from "src/redux/actions/CrewSchedule/CrewSchedule.Actions";
import { checkOS } from "src/utils";

export const crewScheduleAxisLimitInMilliseconds = 1.8 * 2629743000; //the duration of 2 month

export const handleWheel =
  (
    WaterfallGL: React.MutableRefObject<WaterfallGL>,
    mount: React.MutableRefObject<HTMLDivElement>,
    isAnimating: boolean,
    start: () => void,
    windowId: string,
    dispatch: Dispatch<any> | null
  ) =>
  (event: React.WheelEvent): void => {
    const axisToUse = event.deltaY;
    if (Math.floor(axisToUse) === 0) {
      return;
    }
    if (event.shiftKey || event.altKey) {
      const delta = axisToUse >= 1 ? 100 : -100;
      const [minTime, maxTime] = WaterfallGL.current.getTimeRange();
      if (delta < 0 || maxTime - minTime < crewScheduleAxisLimitInMilliseconds) {
        WaterfallGL.current.zoomCamera(delta);
        if (!isAnimating) {
          start();
        }
      }
      // If dispatch is passed in, this timeline is an actively linked timeline, dispath time range.
      if (dispatch && windowId) {
        const [start, end] = WaterfallGL.current.getTimeRange();
        dispatch(setTimelineLink(start, end, windowId));
      }
    } else {
      const scrollAmount = axisToUse > 0 ? 36 : -36; // Adjusted to scroll by exactly one row.
      WaterfallGL.current.moveCameraByYPixels(scrollAmount);
      if (!isAnimating) {
        start();
      }
    }
  };
